/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./LatestAttendanceCounter.vue?vue&type=template&id=776e60ce&scoped=true&"
import script from "./LatestAttendanceCounter.vue?vue&type=script&setup=true&lang=js&"
export * from "./LatestAttendanceCounter.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./LatestAttendanceCounter.vue?vue&type=style&index=0&id=776e60ce&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776e60ce",
  null
  
)

export default component.exports